import { RefObject, useMemo } from 'react';

import { NumberFieldProps, NumberFieldSize } from '../number-field.types';

type UseNumberFieldMetaProps = NumberFieldProps & {
  inputRef: RefObject<HTMLInputElement>;
};

export function useNumberFieldMeta(props: UseNumberFieldMetaProps) {
  return useMemo(() => {
    const {
      inputRef,
      inputSize = NumberFieldSize.Default,
      onValueChange,
      formatOptions,
      ...inputProps
    } = props;

    const stepperProps = {
      ...formatOptions,
      inputRef,
    };

    const formatProps = {
      stepperProps,
      onBlur: props.onBlur,
      onValueChange,
    };

    const stepperEventsProps = {
      stepperProps,
      inputSize,
      onKeyDown: props.onKeyDown,
      onValueChange,
    };

    return {
      inputProps: {
        ...inputProps,
        type: 'text',
        inputSize,
      },
      formatProps,
      stepperProps: stepperEventsProps,
    };
  }, [props]);
}
